module.exports = __webpack_public_path__ + "img/paoduct2.a1b7b0bd.png";